import { render, staticRenderFns } from "./CrossDataTypeComparison.vue?vue&type=template&id=00595b7c&"
import script from "./CrossDataTypeComparison.vue?vue&type=script&lang=js&"
export * from "./CrossDataTypeComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports